export default {
  DEGREE: {
    OTHERS: '其他',
    JUNIOR_SCHOOL: '初中',
    HIGH_SCHOOL: '高中',
    SECONDARY_TECHNICAL_SCHOOL: '中专',
    JUNIOR_COLLEGE: '大专',
    GRADUATE: '本科（无学位）',
    BACHELOR: '学士/本科',
    MASTER: '硕士',
    PHD: '博士'
  },
  JOB_TYPE: {
    SCHOOL_LEAVER: '学校毕业生',
    EXPERIENCED: '有经验的'
  },
  ROLE_TYPE: {
    FULL_TIME: '全职',
    PART_TIME: '兼职',
    INTERNSHIP: '实习'
  },
  LANGUAGE: {
    ARABIC: '阿拉伯语',
    CANTONESE: '粤语',
    ENGLISH: '英语',
    FRENCH: '法语',
    GERMAN: '德语',
    HINDI_OR_URDU: '印度斯坦语',
    ITALIAN: '意大利语',
    JAPANESE: '日语',
    KOREAN: '韩语',
    MANDARIN: '普通话',
    RUSSIAN: '俄罗斯语',
    SPANISH: '西班牙语',
    TAMIL: '泰米尔语',
    MALAY: '马来语',
    BURMESE: '缅甸语',
    KHMER: '高棉语',
    TETUM: '德顿语',
    PORTUGUESE: '葡萄牙语',
    INDONESIAN: '印度尼西亚语',
    LAO: '老挝语',
    BENGALI: '孟加拉语',
    FILIPINO: '菲律宾语',
    THAI: '泰国语',
    VIETNAMESE: '越南语',
    SINHALESE: '僧伽罗语'
  },
  LANGUAGE_LEVEL: {
    NATIVE: '母语',
    FLU: '听说熟练，读写熟练',
    SCC: '听说熟练，读写一般',
    LIT: '听说一般，读写熟练',
    BAS: '听说一般，读写一般'
  },
  CERTIFICATION: {
    CET4: '大学英语4级',
    CET6: '大学英语6级',
    TEM4: '英语专业4级',
    TEM8: '英语专业8级',
    PETS1: '公共英语1',
    PETS2: '公共英语2',
    PETS3: '公共英语3',
    PETS4: '公共英语4',
    PETS5: '公共英语 5',
    TOEFL: '托福',
    IELTS: '雅思',
    OTHER: '其他'
  },
  CHAT_TOOL: {
    QQ: 'QQ',
    ALWW: '阿里旺旺',
    FLY_XIN: '飞信',
    LINE: 'LINE',
    MI_LIAO: '米聊',
    MO_MO: '沫沫',
    MSN: 'MSN',
    PAPA: '啪啪',
    SKYPE: 'Skype',
    TM: 'TM',
    YY: 'YY语音'
  },
  SOCIAL_NETWORK: {
    BAI_DU_TIE_BA: '百度贴吧',
    BLOG: 'Blog',
    DOU_BAN: '豆瓣网',
    FACEBOOK: 'Facebook',
    KAIXIN: '开心网',
    LINKEDIN: 'LinkedIn',
    MOP: '猫扑',
    QQ_ZONE: 'QQ空间',
    REN_REN: '人人网',
    SOHU_WEI_BO: '搜狐微博',
    TIANYA: '天涯',
    TWITTER: 'Twitter',
    TENCENT_WEI_BO: '腾讯微博',
    WEICHAT: '微信',
    SINA_WEI_BO: '新浪微博'
  }
}
